import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ActivationEnd, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/services/http/auth.service';



@Component({
  selector: 'app-global-sidemenu',
  templateUrl: './global-sidemenu.component.html',
  styleUrls: ['./global-sidemenu.component.scss']
})
export class GlobalSidemenuComponent implements OnInit {

  public SelectedItem: any = 3;
  @Input() expandSidebar: boolean = false;
  @Output() expandSidebarChange = new EventEmitter();

  constructor(public authService: AuthService, public toastr: ToastrService,
    private router: Router) { 
      this.router.events
        .subscribe(
          (event) => {
            if(event instanceof ActivationEnd && event.snapshot.children.length == 0) {
              this.SelectedItem = event.snapshot.data['sidebarItem'];
            }
          });
    }

  ngOnInit(): void {
  }

  logout(){ 
    this.authService.logout().subscribe(response => {
        let token = localStorage.removeItem('token');
        this.router.navigate(['/login']);
    }, error => {
      this.toastr.error('An error occurred.');
    });
  }

  expand(){
    this.expandSidebar = !this.expandSidebar;
    this.expandSidebarChange.emit(this.expandSidebar);
  }

  alert(){
    this.toastr.warning("Not yet implemented");
  }

  navigateTo(url: string){
    window.location.href = url
  }
}
